async function checkPincode() {
  const pincode = document.getElementById("pincode").value;
  const resultDiv = document.getElementById("result");

  if (!pincode || pincode.length !== 6) {
    resultDiv.innerHTML = "Please enter a valid 6-digit pincode.";
    return;
  }

  resultDiv.innerHTML = "Checking...";

  try {
    const response = await fetch(
      "https://main.d317fv511yfxyh.amplifyapp.com/api/check-pin",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ pincode }), // Sending pincode in body
      }
    );

    const data = await response.json();
    console.log("API Response:", data); // Debugging log

    // Check if data.data exists and has available_courier_companies
    if (
      response.status === 200 &&
      data.data?.available_courier_companies?.length
    ) {
      const etd = data.data.available_courier_companies[0].etd; // Corrected access
      resultDiv.innerHTML = `<p><b>Expected Delivery:</b> ${etd}</p>`;
    } else {
      resultDiv.innerHTML = "No available courier services for this pincode.";
    }
  } catch (error) {
    console.error("Error:", error);
    resultDiv.innerHTML = "Error fetching data. Please try again.";
  }
}
